var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.currentPage,"page-sizes":_vm.pageSizes,"pager-count":_vm.pageCount,"page-size":_vm.pageSize,"layout":_vm.layout,"total":_vm.total},on:{"size-change":_vm.pageSizeChange,"current-change":_vm.currentPageChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }